import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

// import JS files
import CustomerOrderCard from "../../shares/CustomerOrderCard";
import OrderCardLeftPartTemplate from "../../../shares/OrderCardLeftPartTemplate";
import useFetch from "../../../../context/useFetch";
import TableIconModal from "../../../shares/TableIconModal";
import { useSetting } from "../../../../context/SettingContext";
// import { defaultRingSize } from "../../../../constants/constants";

const OrderDetails = (props) => {
  let windowWidth = window.screen.width;
  const {defaultRingSize} = useSetting()
  const [openModal, setOpenModal] = useState(false);

  const [receviedOerdersDetail, setReceviedOerdersDetail] = useState({
    results: [],
    detail: {},
  });

  const [nums, setNums] = useState(new Array(defaultRingSize + 1).fill(""));
  const update_nums = (ind, nValue) => {
    let beforeNums = [...nums];
    beforeNums[ind] = nValue;
    setNums(beforeNums);
  };

  const getReceviedOerdersDetailApi = useFetch({
    method: "get",
    url: `Order_Service/${props.selectedRow?.id}/user_get_order_item_detail_from_order`,
    trigger: false,
    setter: setReceviedOerdersDetail,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  useEffect(() => {
    if (openModal == true)
      if (props.selectedRow !== undefined)
        if (props.selectedRow.hasOwnProperty("id")) {
          getReceviedOerdersDetailApi.reFetch();
        }
  }, [openModal]);

  return (
    <>
      <TableIconModal
        width="w-11/12"
        icon={<RemoveRedEyeIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <div>
          <div className="flex items-center justify-center mb-2">
            <span className="show-label">
              سند:{" "}
              <span className="show-value">
                {" "}
                {receviedOerdersDetail.detail?.unique_id}
              </span>
            </span>
          </div>

          {receviedOerdersDetail.results.map((item, index) => {
            return [
              <CustomerOrderCard item={item} disabled>
                <OrderCardLeftPartTemplate
                  nums={nums}
                  update_nums={update_nums}
                  dynamicMap={true}
                  data_item={item}
                  ringIndex={index}
                  adminCantEdit
                  showAcceptOrRejectFromAdmin
                  adminDidntNeedCustomerRequestNum
                  adminNeedColor
                />
              
              </CustomerOrderCard>,
            ];
          })}
        </div>
      </TableIconModal>
    </>
  );
};

export default OrderDetails;
